import { hubApplication } from './hub';
import { lensApplication } from './lens';
import { pixelRadApplication } from './pixel-rad';
import { nextIntelligenceApplication } from './next-intelligence';
import { nextPlatformApplication } from './next-platform';
import { trialsApplication } from './trials-app';
import { progeny2Application } from './progeny2';

export const APPLICATIONS = [
  hubApplication,
  lensApplication,
  pixelRadApplication,
  nextIntelligenceApplication,
  nextPlatformApplication,
  trialsApplication,
  progeny2Application,
];
